const shortcutClasses = {
    plus: 'keyPlus',
    controlEnter: 'keyControlEnter',
    controlP: 'keyControlP',
}

// Requisitos de los botones para habilitar los atajos:
// - Agregar: keyPlus y un data-detail con la accion normal del boton.
// - Guardar o actualizar: keyControlEnter.
// - Guardar e imprimir o actualizar e imprimir: keyControlP.
// El boton visible no puede tener la clase dn, ni estar dentro de un contenedor con dn.

export function start(detail) {
    const shortcutClass = shortcutClasses[detail.act]

    if (shortcutClass === undefined) {
        return false
    }

    if (detail.act === 'plus') {
        return openActivePageFullcont(detail.ev, shortcutClass)
    }

    return clickActiveFullcontButton(detail.ev, shortcutClass)
}

function clickActiveFullcontButton(ev, shortcutClass) {
    const fullcont = getActiveFullcont()

    if (fullcont === null || hasOpenOverlay()) {
        return false
    }

    const button = getVisibleButton(fullcont, shortcutClass)

    if (button === null) {
        return false
    }

    ev.preventDefault()

    if (!ev.repeat) {
        // Ejecuta el click normal para conservar las validaciones de cada entidad.
        button.click()
    }

    return true
}

function openActivePageFullcont(ev, shortcutClass) {
    if (getActiveFullcont() !== null || hasOpenOverlay()) {
        return false
    }

    const button = getActivePageButton(shortcutClass)

    if (button === null) {
        return false
    }

    ev.preventDefault()

    if (!ev.repeat) {
        button.click()
    }

    return true
}

function getActivePageButton(shortcutClass) {
    const visiblePages = document.querySelectorAll('.page.page_main:not(.dn)')
    let button = null

    visiblePages.forEach((page) => {
        if (page.id.endsWith('-right')) {
            return
        }

        const pageButton = getVisibleButton(page, shortcutClass)

        if (pageButton !== null) {
            button = pageButton
        }
    })

    return button
}

function getVisibleButton(container, shortcutClass) {
    const buttons = container.querySelectorAll(`.${shortcutClass}`)

    for (const button of buttons) {
        if (button.hasAttribute('data-detail') && isVisible(button)) {
            return button
        }
    }

    return null
}

function isVisible(element) {
    if (element.classList.contains('dn') || element.closest('.dn') !== null) {
        return false
    }

    let current = element

    while (current !== null) {
        const style = window.getComputedStyle(current)

        if (style.display === 'none' || style.visibility === 'hidden') {
            return false
        }

        current = current.parentElement
    }

    return element.getClientRects().length > 0
}

function hasOpenOverlay() {
    return document.querySelector(
        '.dialog-show, .quickview-show, .quickform-show, .backdrop-show, .menu-show'
    ) !== null
}

function getActiveFullcont() {
    // Excluye los fullcont cerrados, los que se estan ocultando y los de paginas inactivas.
    const openFullconts = document.querySelectorAll(
        '.fullcont.fullcont-show:not(.fullcont-hide)'
    )
    let activeFullcont = null
    let activeZIndex = -Infinity

    openFullconts.forEach((fullcont) => {
        if (fullcont.closest('.page_main.dn') !== null) {
            return
        }

        const parsedZIndex = parseInt(window.getComputedStyle(fullcont).zIndex, 10)
        const zIndex = Number.isNaN(parsedZIndex) ? 0 : parsedZIndex

        // Si comparten z-index, el ultimo fullcont del DOM se considera activo.
        if (activeFullcont === null || zIndex >= activeZIndex) {
            activeFullcont = fullcont
            activeZIndex = zIndex
        }
    })

    return activeFullcont
}
